// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2coQ2","author":"Table_author__3Y6tn","authorImage":"Table_authorImage__S4X_d","unreadRow":"Table_unreadRow__WXba1"};